var React = require('react');

function Card (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0,30H30V0H0Z","fill":"rgba(255,255,255,0.01)","fillRule":"evenodd","key":0}),React.createElement("path",{"d":"M6.5,10H26.491a2.5,2.5,0,0,1,2.5,2.5V24.977a2.5,2.5,0,0,1-2.5,2.5H6.5a2.5,2.5,0,0,1-2.5-2.5V12.5A2.5,2.5,0,0,1,6.5,10ZM5.249,14.992v2.5H27.74v-2.5ZM27.74,13.744H5.249V12.5A1.25,1.25,0,0,1,6.5,11.248H26.491A1.25,1.25,0,0,1,27.74,12.5Zm0,4.993H5.249v6.241A1.25,1.25,0,0,0,6.5,26.226H26.491a1.25,1.25,0,0,0,1.249-1.248ZM15.87,23.729h-7.5a.624.624,0,1,1,0-1.248h7.5a.624.624,0,1,1,0,1.248Zm6.872,0h1.874a.624.624,0,1,0,0-1.248H22.742a.624.624,0,1,0,0,1.248Z","transform":"translate(-1.495 -3.737)","fill":"currentColor","fillRule":"evenodd","key":1})]);
}

Card.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = Card;

Card.default = Card;



//////////////////
// WEBPACK FOOTER
// ./src/components/iframes/checkout/assets/card.svg
// module id = 1400
// module chunks = 0